<template>
  <div class="text-container body-m-regular">
    <Transition>
      <span v-if="textLoaded">{{ complimentText }}</span>
    </Transition>
  </div>
</template>

<script>
import { ClientHomeService } from '../services/api'

const FALLBACK_MESSAGE = 'Other workplaces envy the excellence you create with Crafty.'

export default {
  name: 'ClientHomePageCompliments',
  data() {
    return {
      complimentText: '',
      textLoaded: false,
    }
  },
  mounted() {
    this.fetchCompliment()
  },
  methods: {
    async fetchCompliment() {
      try {
        const { data } = await ClientHomeService.compliment()
        this.complimentText = data
      } catch (error) {
        this.complimentText = FALLBACK_MESSAGE
      } finally {
        this.textLoaded = true
      }
    },
  },
}
</script>

<style scoped lang="scss">
  .v-enter-active {
    transition: opacity 1.0s ease;
  }
  .v-enter-from {
    opacity: 0;
  }
</style>
